// Import Packages
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { ObjectInspector, chromeDark } from 'react-inspector';

// Import Material UI
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

// Import Recoil
import { alertState, personalizationState } from '../../../../recoil-store/recoil-state';
import { useRecoilValue, useSetRecoilState } from 'recoil';

// Import Icons
import startedIcon from '../../../../assets/icons/started-icon.svg';
import infoIcon from '../../../../assets/icons/info-icon.svg';
import completedIcon from '../../../../assets/icons/completed-icon.svg';
import actionStartedIcon from '../../../../assets/icons/configurationIcons/monitoring-action-started-icon.svg';
import actionCompletedIcon from '../../../../assets/icons/configurationIcons/monitoring-action-completed-icon.svg';
import actionInfoIcon from '../../../../assets/icons/configurationIcons/monitoring-action-info-icon.svg';
import actionErrorIcon from '../../../../assets/icons/configurationIcons/monitoring-action-error-icon.svg';
import { convertToDateFormat } from '../../../../helpers/helper';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { CircularProgress, Tooltip } from '@material-ui/core';
import LogService from '../../../../services/LogService/LogService';



const MidLogsDetail = ({ data, log, index, names, img, logType, highlightText, searchTerm, findedOpetaionGroupIds }) => {
    const [expand, setExpand] = useState(false)
    const [logDetail, setLogDetail] = useState([])
    const [loading, setLoading] = useState(false)
    const setAlert = useSetRecoilState(alertState);
    const personalization = useRecoilValue(personalizationState);
    const { t } = useTranslation();
    const label = "MESSAGES.MONITORING."


    useEffect(() => {
        if (findedOpetaionGroupIds?.length) {
            const isFinded = findedOpetaionGroupIds.find(id => id === log.log_group_id);
            if (isFinded) {
                setExpand(true)
                fetchLogDetails()
                return
            }
        }
        if (expand) {
            setExpand(false)
        }
    }, [findedOpetaionGroupIds, log])

    const fetchLogDetails = async () => {
        setLoading(true)
        const response = await LogService.getLogsByGroupId(data?.operation_id, log.log_group_id)
        if (response.status) {
            setLogDetail(response.data)
            setLoading(false)
            return response.data
        }
        setLoading(false)
    }

    const handleExpandRow = async (e, copy) => {
        if (loading) {
            return
        }
        if (!expand) {
            const response = await fetchLogDetails()
            const text = response?.text
            if (copy && text) {
                handleCopy(e, text)
            }
        }
        else if (expand) {
            const text = logDetail?.text
            if (copy && text) {
                handleCopy(e, text)
            }
            // setLogDetail([])
        }
        if (e?.target?.localName === "path") {
            if (e.target?.parentElement?.classList) {
                const classList = e.target.parentElement.classList
                if (Object.values(classList)?.includes("log-json-copy-icon")) {
                    return
                }
            }
        }
        if (logType) {
            return
        }
        setExpand((pre) => !pre)
    }

    const customTheme = {
        ...chromeDark, // chromeDark temasını baz al
        BASE_BACKGROUND_COLOR: 'transparent', // Arka plan rengini değiştir
        BASE_COLOR: 'black', // Metin rengini değiştir
        TREENODE_FONT_SIZE: '12px',
        TREENODE_LINE_HEIGHT: '1.5',
        ARROW_COLOR: "#5F5F5F"
    };

    const handleCopy = async (e, text) => {
        try {
            await navigator.clipboard.writeText(text);
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t(label + `COPIED`),
                severity: 'success'
            }));
            e.preventDefault()
            e.stopPropagation()
            if (!expand) {
                setExpand(true)
            }
        } catch (err) {
        }
    };

    const findLogIcon = (tag) => {
        switch (tag) {
            case "action_started":
                return actionStartedIcon
            case "action_ended":
                return actionCompletedIcon
            case "info":
                return actionInfoIcon
            case "error":
                return actionErrorIcon

            default:
                return actionInfoIcon
                break;
        }
    };

    // Highlight strings within objects
    const highlightObject = (data, term) => {
        if (typeof data === 'string') {
            return highlightText(data, term); // Apply highlight to strings
        } else if (Array.isArray(data)) {
            // For arrays, apply highlighting recursively to each element
            return data.map((item, index) => <div key={index}>{highlightObject(item, term)}</div>);
        } else if (typeof data === 'object' && data !== null) {
            // For objects, recursively apply highlighting to each value
            return Object.fromEntries(
                Object.entries(data).map(([key, value]) => [key, highlightObject(value, term)])
            );
        }
        return data; // For numbers, booleans, etc., return as is
    };

    const CustomNodeRenderer = ({ depth, name, data, isNonenumerable, searchTerm }) => {
        // Check if the data is a string, and highlight it if it contains the search term
        const highlightedData = typeof data === 'string' && searchTerm
            ? highlightText(data, searchTerm)
            : data;

        return (
            <div style={{ marginLeft: depth * 10 }}>
                {name && (
                    <span style={{ color: chromeDark.NAME_COLOR }}>
                        {name}:
                    </span>
                )}
                {typeof highlightedData === 'string' ? (
                    <span>{highlightedData}</span>
                ) : (
                    <ObjectInspector data={highlightedData} /> // Recursively render objects or arrays
                )}
            </div>
        );
    };

    const CustomObjectInspector = ({ data, searchTerm }) => {
        return (
            <ObjectInspector
                data={data}
                theme={chromeDark}
                nodeRenderer={(props) => <CustomNodeRenderer {...props} searchTerm={searchTerm} />}
            />
        );
    };

    return (
        <div className={`log-row-container ${expand ? "bigger-row" : ""} ${log.level?.toLowerCase()}`}>
            <div className="log-row" onClick={(e) => handleExpandRow(e)}>
                <div className='group-column'>
                    <span className='index-number' >{index + 1}.</span>
                    <div className={`log-level-column log-${log.level?.toLowerCase()}`}>{highlightText(t(label + `${log.level}`).toUpperCase(), searchTerm, index)}</div>
                    <img className='log-action-image' src={img} alt='action-image' />
                    {/* <p>{log.defination}</p> */}
                    <p className='log-action-name' >
                        {log.action_name ? <>
                            {log.label ?
                                <span>{highlightText(log.label, searchTerm, index)}</span> :
                                <>
                                    <span>
                                        {highlightText(log.library_label.includes('CUSTOM') ? log.library_name :
                                            t("CONTENT.LIBRARY." + log.library_name + ".NAME"), searchTerm, index)}
                                        {/* {t("CONTENT.LIBRARY." + log.library_name + ".NAME")} */}
                                    </span>
                                    <span className='action-library-name-seperator'> - </span>
                                    <span>
                                        {highlightText(log?.library_label?.includes('CUSTOM') ? log?.action_name :
                                            t(`CONTENT.LIBRARY.${log.library_name}.ACTION.${log.action_name}`), searchTerm, index)}
                                        {/* {t(`CONTENT.LIBRARY.${log.library_name}.ACTION.${log.action_name}`)} */}
                                    </span>
                                </>
                            }

                        </>
                            : logType ? logType : log.level === "TRIGGER-PARAM" ? "" : "-"}
                    </p>
                    {log.level === "TRIGGER-PARAM" ?
                        <Tooltip title={t(label + `COPY-PAYLOAD`)} placement="bottom" >
                            <FileCopyIcon className='log-json-copy-icon' onClick={(e) => handleExpandRow(e, true)} />
                        </Tooltip>
                        : ""}
                </div>
                {logType ? <p className='time-of-log'>{log?.created_at ? convertToDateFormat(log?.created_at, personalization.date_format) : "-"}</p> : ""}
                {!logType
                    ? loading
                        ? <CircularProgress size={14} />
                        : !expand ? <ExpandMoreIcon className='expand-collapse-icon' /> : <ExpandLessIcon className='expand-collapse-icon' />
                    : ""}
            </div>
            {
                expand ?
                    <>
                        {/* <div className='child-log-row first-child-log'>
                            <div className='group-column'>
                                <img className='log-action-image' src={infoIcon} />
                                {log.level === "TRIGGER-PARAM" ? <ObjectInspector data={log.text ? JSON.parse(log.text) : {}} theme={customTheme} />
                                    : <p>{log.text}</p>}
                            </div>
                            <p className='time-of-log'>{log?.created_at ? convertToDateFormat(log?.created_at, personalization.date_format) : "-"}</p>
                        </div> */}
                        <div className="timeline">
                            {logDetail.length ? logDetail.map((log) => {
                                const source = findLogIcon(log.tag)
                                return <div className="timeline-item">
                                    <img className='circle' src={source} />
                                    <div className="timeline-content">
                                        <h4> {log.level === "TRIGGER-PARAM" ? <ObjectInspector data={log.text ? JSON.parse(log.text) : {}} theme={customTheme} />
                                            : highlightText(log.text, searchTerm, index)} </h4>
                                        <p>{convertToDateFormat(log.created_at, personalization.date_format)}</p>
                                    </div>
                                </div>
                            })

                                : ""}
                        </div>

                        {/* <div className='child-log-row first-child-log'>
                            <div className='group-column'>
                                <img className='log-action-image' src={startedIcon} />
                                <p>{t(label + `STARTED`)}</p>
                            </div>
                            <p className='time-of-log'>{log?.created_at ? convertToDateFormat(log?.created_at) : "-"}</p>
                        </div>
                        <div className='child-log-row'>
                            <div className='group-column'>
                                <img className='log-action-image' src={completedIcon} />
                                <p>{t(label + `COMPLETED`)}</p>
                            </div>
                            <p className='time-of-log'>{log?.completed_at ? convertToDateFormat(log?.completed_at) : "-"}</p>
                        </div> */}
                    </>
                    : ""
            }
        </div >
    )
}

export default MidLogsDetail